import {BookingFlowInstanceRestService, CalendarService} from './restServices';
import storageService from '../storageService';

const service = {};

service.createBookingFlowInstance = (
  bookingFlowInstanceDto,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var newRequestObject = {
    token: token ? token : storageService.getItem('token'),
    bookingFlowInstanceDto: bookingFlowInstanceDto,
  };
  BookingFlowInstanceRestService.save(
    {},
    newRequestObject,
    (resource) => {
      // debugger;
      successCallbackFunction(resource?.data?.bookingFlowInstanceDto);
    }, // success
    (response) => {
      // debugger;
      console.debug(response.data);
      if (failCallbackFunction) {
        failCallbackFunction(response.data);
      }
    },
  ); // failure
};
service.createReserveBfi = (
  bookingFlowInstanceDto,
  successCallbackFunction,
  failCallbackFunction,
) => {
  BookingFlowInstanceRestService.save(
    {endpoint: 'reserve'},
    {bookingFlowInstanceDto},
    (resource) => {
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource?.data?.reservedBookingFlowInstanceDto);
      }
    },
    (response) => {
      console.debug(response.data);
      if (failCallbackFunction) {
        failCallbackFunction(response.data);
      }
    },
  );
};
service.getBookingFlowInstanceDtosByUserId = (
  // if fromDate, toDate exist, backend will ignore the pageNum and Count.
  userId,
  pageNum,
  pageSize,
  fromDate,
  toDate,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  BookingFlowInstanceRestService.get(
    {
      endpoint: 'userId',
      endpointParam: userId,
      token: token ? token : storageService.getItem('token'),
      pageNumber: pageNum,
      pageSize: pageSize,
      fromDate,
      toDate,
    },
    {},
    (resource) => {
      successCallbackFunction(resource?.data);
    },
    (response) => {
      failCallbackFunction(response);
    },
  );
};
service.getBookingFlowInstanceDtosByMentorIds = (
  // if fromDate, toDate exist, backend will ignore the pageNum and Count.
  mentorIds,
  pageNum,
  pageSize,
  fromDate,
  toDate,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  BookingFlowInstanceRestService.get(
    {
      endpoint: 'mentorIds',
      mentorIds,
      token: token ? token : storageService.getItem('token'),
      pageNumber: pageNum,
      pageSize: pageSize,
      fromDate,
      toDate,
    },
    {},
    (resource) => {
      successCallbackFunction(resource?.data);
    },
    (response) => {
      failCallbackFunction(response);
    },
  );
};
service.getBookingFlowInstancesSorted = (
  userId,
  dateFrom,
  dateTo,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  BookingFlowInstanceRestService.get(
    {
      endpoint2: 'userId',
      endpointParam2: userId,
      endpoint: 'dateRange',

      token: token ? token : storageService.getItem('token'),
      dateFrom,
      dateTo,
      pageNum: 0,
      pageSize: 200,
    },
    {},
    (resource) => {
      successCallbackFunction(resource?.data);
    },
    (response) => {
      failCallbackFunction(response);
    },
  );
};
service.getBookingFlowInstancesSortedByMentorIds = (
  mentorIds,
  dateFrom,
  dateTo,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  BookingFlowInstanceRestService.get(
    {
      endpoint2: 'mentorIds',
      endpoint: 'dateRange',
      mentorIds,
      token: token ? token : storageService.getItem('token'),
      dateFrom,
      dateTo,
      pageNum: 0,
      pageSize: 200,
    },
    {},
    (resource) => {
      successCallbackFunction(resource?.data);
    },
    (response) => {
      failCallbackFunction(response);
    },
  );
};

service.getBookingFlowInstanceByBookingFlowInstanceId = (
  bookingFlowInstanceId,
  isGuest,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {};
  BookingFlowInstanceRestService.get(
    {
      endpoint: 'bookingFlowInstanceId',
      endpointParam: bookingFlowInstanceId,
      endpoint2: 'isGuest',
      token: token ? token : storageService.getItem('token'),
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.getAlreadyBookedTimeRangesByDate = (
  mentorUserIds,
  startDate,
  endDate,
  successCallbackFunction,
  failCallbackFunction,
) => {
  var requestObject = {};
  BookingFlowInstanceRestService.get(
    {
      endpoint: 'bookedTimeRangesByDate',
      endpoint2: 'mentorUserIds',
      mentorUserIds,
      startDate,
      endDate,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.toggleBookingFlowInstanceRead = (
  bookingFlowInstanceId,
  userId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    userId: userId,
  };
  BookingFlowInstanceRestService.update(
    {
      endpoint: 'toggle',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      failCallbackFunction(response);
      console.debug(response);
    },
  );
};
// TODO: Need to verify delete verb
service.deleteBookingFlow = (
  bookingFlowInstanceId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
  };
  BookingFlowInstanceRestService.delete(
    {
      endpoint: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.cancelReservedBfi = (
  bookingFlowInstanceId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  BookingFlowInstanceRestService.delete(
    {
      endpoint: 'reserve',
      endpointParam: bookingFlowInstanceId,
    },
    {},
    (resource) => {
      console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    (response) => {
      console.debug(response);
      if (failCallbackFunction) {
        failCallbackFunction(response);
      }
    },
  );
};

service.acceptBookingFlowInstance = (
  bookingFlowInstanceId,
  confirmedStartTime,
  confirmedEndTime,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    confirmedStartTime,
    confirmedEndTime,
  };
  BookingFlowInstanceRestService.update(
    {
      endpoint: 'confirm',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};
service.cancelBookingFlowInstance = (
  bookingFlowInstanceId,
  message,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    message,
  };
  BookingFlowInstanceRestService.update(
    {
      endpoint: 'cancel',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.rebookBookingFlowInstance = (
  bookingFlowInstanceId,
  bookingFlowInstanceDto,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    newBookingFlowInstanceDto: bookingFlowInstanceDto,
  };
  BookingFlowInstanceRestService.save(
    {
      endpoint: 'rebook',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.getBfiByRebookedBfiId = (
  bookingFlowInstanceId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  BookingFlowInstanceRestService.get(
    {
      endpoint: 'rebookedBookingFlowInstanceId',
      endpointParam: bookingFlowInstanceId,
    },
    {},
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.declineBookingFlowInstance = (
  bookingFlowInstanceId,
  message,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  var requestObject = {
    token: token ? token : storageService.getItem('token'),
    message,
  };
  BookingFlowInstanceRestService.update(
    {
      endpoint: 'reject',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};
service.checkGoogleCalenderSyncState = async () => {
  const response = await CalendarService.get(
    {
      endpoint: 'googleStatus',
    },
    {token: storageService.getItem('token')},
  );
  return response;
};

service.sendGCalendarAuthCode = async (authCode, token) => {
  const response = await CalendarService.save(
    {
      endpoint: 'googleAuthCode',
    },
    {token: token ? token : storageService.getItem('token'), code: authCode},
  );
  return response;
};

service.cancelGoogleCalendarSync = async () => {
  const response = await CalendarService.delete(
    {
      endpoint: 'googleAuthCode',
    },
    {token: storageService.getItem('token')},
  );
  return response;
};

service.modifyBookingFlowInstance = (
  bookingFlowInstanceId,
  bookingFlowInstanceDto,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
    bookingFlowInstanceDto,
  };
  BookingFlowInstanceRestService.update(
    {endpoint: 'modify', endpointParam: bookingFlowInstanceId},
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.dismissBookingFlowInstanceProposals = (
  bookingFlowInstanceId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
  };
  BookingFlowInstanceRestService.update(
    {endpoint: 'dismissProposals', endpointParam: bookingFlowInstanceId},
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};
service.proposeNewTimeBookingFlowInstance = (
  bookingFlowInstanceId,
  proposals,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
    proposals,
  };
  BookingFlowInstanceRestService.update(
    {
      endpoint: 'propose',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.acceptProposalOfBookingFlowInstance = (
  bookingFlowInstanceId,
  confirmedStartTime,
  confirmedEndTime,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
    confirmedStartTime,
    confirmedEndTime,
  };
  BookingFlowInstanceRestService.update(
    {
      endpoint: 'acceptProposal',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

service.addGuestToBookingFlowInstance = (
  bookingFlowInstanceId,
  addedRecipients,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {
    token: token ? token : storageService.getItem('token'),
    addedRecipients,
  };
  BookingFlowInstanceRestService.update(
    {
      endpoint: 'invite',
      endpointParam: bookingFlowInstanceId,
    },
    requestObject,
    (resource) => {
      console.debug(resource);
      successCallbackFunction(resource);
    },
    (response) => {
      console.debug(response);
      failCallbackFunction(response);
    },
  );
};

const bookingFlowInstanceService = {...service};
export default bookingFlowInstanceService;
